import type { Table } from "@/store/types";

/**
 * Walk the bidirectional ``neighbors`` graph from ``rootId`` and return every
 * reachable table id (including the root). Used to:
 *
 * 1. Highlight the full connected component of a tapped table (halo, capacity
 *    pill).
 * 2. Look up whether a registered ``TableGroup`` covers exactly this set.
 */
export function findConnectedGroup(rootId: string, tables: Table[]): string[] {
  const byId = new Map(tables.map((t) => [t.id, t]));
  const visited = new Set<string>([rootId]);
  const queue: string[] = [rootId];
  while (queue.length > 0) {
    const id = queue.shift() as string;
    const t = byId.get(id);
    if (!t) continue;
    for (const n of t.neighbors) {
      if (!visited.has(n)) {
        visited.add(n);
        queue.push(n);
      }
    }
  }
  return Array.from(visited);
}
